import ApiService from "../../common/apiService";
import { getData } from "../../common/dataHelper";
import { AUTH_USER_TYPES, MEDIA_TYPES, STORE_TYPES } from "../types";
const state = { materials: [] };

const getters = {
    [MEDIA_TYPES.GET_MATERIALS](state) {
        return state.materials;
    },
};

const actions = {
    async [MEDIA_TYPES.UPLOAD_AVATAR]({ commit }, { avatar }) {
        const formData = new FormData();
        formData.append("avatar", avatar);
        const response = await ApiService.post(
            "academy/updateAvatar",
            avatar ? formData : { avatar: null }
        );
        const user = getData(response, "data.customer");
        if (user) {
            commit(
                `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.SET_USER}`,
                user,
                {
                    root: true,
                }
            );
        }
        return response;
    },
    async [MEDIA_TYPES.FETCH_MATERIALS]({ commit }) {
        const response = await ApiService.query("academy/materials");
        const materials = getData(response, "data.materials");
        if (materials) {
            const formatedMaterials = [];
            for (const key in materials) {
                if (Object.hasOwnProperty.call(materials, key)) {
                    const element = materials[key];
                    formatedMaterials.push({ name: key, documents: element });
                }
            }
            commit(MEDIA_TYPES.SET_MATERIALS, formatedMaterials);
        }
        return response;
    },
    async [MEDIA_TYPES.OPEN_MEDIA_IN_NEW_TAB](context, { media }) {
        const route = `${process.env.VUE_APP_API_URL}/academy/media/${media.id}/preview`;

        var link = document.createElement("a");
        link.target = "_blank";
        link.href = route;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return;
    },

    async [MEDIA_TYPES.DOWNLOAD_MEDIA](context, { media }) {
        const route = `${process.env.VUE_APP_API_URL}/academy/media/${media.id}`;
        var link = document.createElement("a");
        link.download = media.name;
        link.href = route;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return;
    },
    async [MEDIA_TYPES.FETCH_MEDIA_AS_BASE](context, { media }) {
        const response = await ApiService.query(
            "academy/media/" + media.id + "/preview?base64"
        );
        return response;
    },
};

const mutations = {
    [MEDIA_TYPES.SET_MATERIALS](state, array) {
        state.materials = array;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
